import React from "react";
import { ErrorMessage, Input, InputGroup } from "rsuite";
import * as mask from "inputmask";
import classNames from "classnames";
import { FormControlBaseProps, StandardProps } from "rsuite/lib/@types/common";
import dayjs from "dayjs";

interface MaskInputProps extends StandardProps, FormControlBaseProps<string> {
    mask?: string[];
    regex?: string;
    required?: boolean;
    onChangeEnd?: any;
    password?: boolean | string;
    isEdit?: boolean;
    password_character?: string;
    oldValue?: string;
    defaultValue?: string;
    placeholder?: string;
    setGlobalState?: Function;
    setValue?: Function;
    setState?: Function;
    setProperties?: Function;
    autoFocus?: boolean;
    onBlur?: Function;
    // componentClass?: React.ElementType;
    // type?: string;
    // id?: string;
    // disabled?: boolean;
    // inputRef?: React.Ref<any>;
    // onPressEnter?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

export class MaskInput extends React.Component<any, {}> {
    public maskSelector = new mask.default("99");

    public activeMask: string = "";

    public hasValidation = this.props.mask || this.props.regex || this.props.required ? true : false;
    public firstRun = false;

    public state: any = {
        value: this.props.value,
        isValid: true,
        isDirty: false,
        showPassword: false,
    };
    public lastDefaultValue = this.props.value;
    public inputRef: any;
    public appliedMaskKey: string = "";
    public lastSyncedValue: any = undefined;
    constructor(props: MaskInputProps) {
        super(props);
        this.inputRef = React.createRef();
        this.setState({ value: this.props.value });
    }

    shouldComponentUpdate = (props: any, state: any) => {
        if (this.props.value !== props.value && this.lastDefaultValue !== props.value) {
            this.lastDefaultValue = props.value ?? -1;
            this.setState({ value: props.value });
        }
        // Mask (re)application + value sync happen in the commit phase
        // (componentDidUpdate), keyed by mask content — never here in render phase.
        return true;
    };

    syncMaskedValue = (val: any) => {
        const el = this.inputRef.current;
        if (!el) return;
        const v = val ?? '';
        this.lastSyncedValue = v;
        if (el.inputmask && typeof el.inputmask.setValue === 'function') {
            el.inputmask.setValue(v);
        } else {
            el.value = v;
            this.applyMask(this.props.mask);
        }
    };

    applyMask = (maskObj : any) => {
        let masker = new mask.default({
            mask: maskObj,
            placeholder: "_",
            showMaskOnFocus: false,
            showMaskOnHover: false,
            jitMasking: false,
            insertModeVisual: false,
            casing: this.props.allowLowercase ? undefined : "upper",
        });
        try {
            if (this.inputRef.current) {
                if (masker) {
                    masker.mask(this.inputRef.current);
                }
            }
        } catch (e) {}
    }

    componentDidUpdate() {
        const key = JSON.stringify(this.props.mask ?? null);
        if (this.props.mask && this.props.password !== "true" && key !== this.appliedMaskKey) {
            this.appliedMaskKey = key;
            this.applyMask(this.props.mask);
            this.lastSyncedValue = undefined; // force re-sync after remask
        }

        if (this.props.mask && this.inputRef.current) {
            const next = this.props.value ?? '';
            if (next !== this.lastSyncedValue) {
                this.syncMaskedValue(next);
            }
        }
        if (this.inputRef.current) {
            this.inputRef.current.onblur = (evt: any) => {
                this.onChangeInput(evt.target.value, evt);
            };
        }
    }

    componentDidMount() {
        this.lastDefaultValue = this.props.value;

        let initialValue = this.state.value;
        if(this.props.value && typeof this.props.value == 'string' && this.props.value.length > 0) {
            if(this.props.value.includes('T') && this.props.value.includes('Z') && dayjs(this.props.value).isValid() && this.props.value.includes(':') && this.props.value.includes('.')){
                initialValue = dayjs(this.props.value).format('DD/MM/YYYY HH:mm:ss');
                this.setState({value: initialValue})
            }
        }
        this.appliedMaskKey = JSON.stringify(this.props.mask ?? null);
        if (this.props.password === "true") {
        } else if (this.props.mask) {
            this.applyMask(this.props.mask);
            this.syncMaskedValue(initialValue);
        }
        if (this.inputRef.current) {
            this.inputRef.current.onblur = (evt: any) => {
                this.onChangeInput(evt.target.value, evt);
            };
        }
        if (this.props.value) {
            this.onChangeInput(this.state.value, null);
        }
    }

    onChange = (value: any) => {
        if (value !== undefined && this.props.allowLowercase === undefined) {
            value = value.toLocaleUpperCase();
        }

        if ((this.props.mask === undefined || this.props.mask.length === 0) && this.props.maxLength) {
            if (value && value.length > this.props.maxLength) {
                value = value.substr(0, this.props.maxLength);
            }
        }
        const input = this.inputRef.current;
        if (this.props.mask && input?.inputmask && value && input.inputmask.unmaskedvalue() === '') {
            input.inputmask.setValue('');
            value = '';
        }
        var savedStart: null | number = input?.selectionStart ?? null;
        var savedEnd: null | number = input?.selectionEnd ?? savedStart;
        this.setState({ value }, () => {
            if (input && savedStart !== null) {
                window.requestAnimationFrame(() => {
                    if (document.activeElement === input) {
                        input.selectionStart = savedStart;
                        input.selectionEnd = savedEnd ?? savedStart;
                    }
                });
            }
        });
    };

    shortestMask = (value: string | null = null) => {
        var shortest = "";
        if (value == null) {
            value = this.state.value ?? "";
        }
        if (value) {
            value = value.replace(/[^a-zA-Z0-9]/g, "");
        }

        if (this.props.mask) {
            for (let i = 0; i < this.props.mask?.length; i++) {
                let mask = this.props.mask[i].replace(/[^a-zA-Z0-9]/g, "");
                if (value !== null) {
                    if (mask.length === value.length || shortest === "") {
                        shortest = this.props.mask[i];
                    }
                }
            }
        }
        this.activeMask = shortest;
        return shortest;
    };
    public lastParsedValue: any = undefined;
    onChangeInput = (value: string, event: React.SyntheticEvent<HTMLElement, Event> | null) => {
        if (this.state.isDirty === false) {
            this.setState({ isDirty: true });
        }
        var isValid = true;
        var outputValue = value;
        // alert(value);
        try {
            if (this.props.mask) {
                this.shortestMask(value);
                const liveMask = this.inputRef.current?.inputmask;
                var masked = liveMask ? liveMask.unmaskedvalue() : mask.default.unmask(outputValue.toString(), { mask: this.props.mask });
                var maskValid = liveMask ? liveMask.isValid() : mask.default.isValid(outputValue.toString(), { mask: this.props.mask });
                outputValue = masked;
                if (maskValid === false && isValid === true) {
                    isValid = false;
                }
                // alert(outputValue);
                // return;
            }
            outputValue = outputValue.replace(/[\t]/g,'');
            if (this.props.regex) {
                try {
                    var regexp = new RegExp(this.props.regex);
                    var regexValid = regexp.test(outputValue);
                    if (regexValid === false && isValid === true) {
                        isValid = false;
                    }
                } catch (e) {
                    console.warn("RegExp inválido = " + this.props.regex);
                }
            }
            if (this.props.required) {
                if (outputValue.length <= 0) {
                    if (isValid === true) {
                        isValid = false;
                    }
                }
            }
        } catch (e) {
            console.warn(e);
        }
        var resultValue = "";
        if (isValid) {
            if (outputValue && outputValue.length) {
                resultValue = outputValue;
            } else {
                resultValue = "";
            }
        }
        if (resultValue !== undefined && this.props.allowLowercase === undefined) {
            resultValue = resultValue.toLocaleUpperCase();
        }

        if (this.lastParsedValue !== resultValue) {
            this.lastParsedValue = resultValue;
            this.setState({ isValid: isValid });

            if (this.props.onChangeEnd) {
                this.props.onChangeEnd(resultValue, event);
            }
            if (this.props.onBlur && isValid && event != null) {
                this.props.onBlur(resultValue);
            }
        }
        // }
        // this.setState({value: resultValue});
    };

    renderError = () => {
        return (
            <ErrorMessage show={true} placement={"bottomEnd"}>
                teste
            </ErrorMessage>
        );
    };

    renderValid = () => {
        if (this.props.password === "true") {
            return (
                <InputGroup.Button onClick={() => this.setState({ showPassword: !this.state.showPassword })}>
                    <i className={classNames("fas fa-fw", "fa-" + (!this.state.showPassword ? "eye" : "low-vision"))}></i>
                </InputGroup.Button>
            );
        }
        if (!this.hasValidation) return null;
        return (
            <InputGroup.Addon>
                {/* <Icon icon="search" /> */}
                {!this.state.isValid && <i className="fas fa-times"></i>}
                {this.state.isValid && <i className="fas fa-check"></i>}
            </InputGroup.Addon>
        );
    };

    validClassName = () => {
        if (this.state.isDirty) {
            return this.state.isValid ? "is-valid" : "is-invalid";
        }
        return "";
    };

    render() {
        if (this.props.hidden) {
            return null;
        }

        return (
            <div className={classNames("rs-form-control-wrapper w-100", this.validClassName())}>

                <InputGroup disabled={this.props.disabled || this.props.readonly}>
                    {this.props.preffix && <InputGroup.Addon>{this.props.preffix}</InputGroup.Addon>}
                    <Input
                        autoFocus={this.props.autoFocus}
                        type={this.props.password === "true" && this.state.showPassword === false ? "password" : "text"}
                        inputRef={this.inputRef}
                        name={this.props.name ?? undefined}
                        onChange={this.onChange}
                        disabled={this.props.disabled || this.props.readonly}
                        // onChange={(evt:any) => this.setState({value: evt.target.value})}
                        placeholder={this.props.mask ? this.props.mask[0] : this.props.placeholder}
                        value={this.props.mask ? undefined : (this.state.value ?? '')}>
                        </Input>

                        {this.props.suffix && <InputGroup.Addon>{this.props.suffix}</InputGroup.Addon>}

                    {(this.state.isDirty === true || this.props.password === "true" || this.props.oldValue) && this.renderValid()}
                    {this.props.maxLength > 0 && this.props.mask === undefined && (
                        <div className="rs-input-meta">
                            {this.state.value ? this.state.value.length : 0}/{this.props.maxLength}
                        </div>
                    )}
                </InputGroup>
            </div>
        );
    }
}
